export const QUOTE_CREATE = 'CS/MORTGAGE/QUOTE_CREATE';
export const QUOTE_CREATE_SUCCESS = 'CS/MORTGAGE/QUOTE_CREATE_SUCCESS';
export const QUOTE_CREATE_ERROR = 'CS/MORTGAGE/QUOTE_CREATE_ERROR';
export const QUOTE_SET_ACTIVE = 'CS/MORTGAGE/QUOTE_SET_ACTIVE';
export const QUOTE_UNSET_ACTIVE = 'CS/MORTGAGE/QUOTE_UNSET_ACTIVE';
export const QUOTE_REDIRECT = 'CS/MORTGAGE/QUOTE_REDIRECT';
export const QUOTE_REFINE = 'CS/MORTGAGE/QUOTE_REFINE';
